"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _changeLogin = require("./changeLogin");
Object.keys(_changeLogin).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _changeLogin[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _changeLogin[key];
    }
  });
});